import React from 'react';
import 'react-tippy/dist/tippy.css';
import {
	Tooltip,
} from 'react-tippy';

const CustomTooltip = ({content}) => {

	return (
		<Tooltip
			html={(
				<div style={{
					width: '238px',
					textAlign: 'left',
					padding: '10px',
					fontWeight: '600'
				}}>
					{content}
				</div>
			)}
			position="bottom"
			arrow={true}
			arrowSize={'regular'}
			className={'c-tooltip'}
		>

		</Tooltip>
	)
}

export default CustomTooltip;
